import React, { useState } from 'react';
import {
  CrumbsContext,
  OwnHeadingContext,
  SetCrumbsContext,
  SetOwnHeadingContext,
  type Crumb,
} from './BreadcrumbContext';

/** Holds the page's crumbs for the header; wraps the app layout. */
export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  const [ownHeadings, setOwnHeadings] = useState(0);
  return (
    <SetCrumbsContext.Provider value={setCrumbs}>
      <SetOwnHeadingContext.Provider value={setOwnHeadings}>
        <OwnHeadingContext.Provider value={ownHeadings}>
          <CrumbsContext.Provider value={crumbs}>
            {children}
          </CrumbsContext.Provider>
        </OwnHeadingContext.Provider>
      </SetOwnHeadingContext.Provider>
    </SetCrumbsContext.Provider>
  );
};
